/**
 * 奖励文案：1 点数 = 1 字符，面向用户统一表述为「字/千字」
 */

function toPoints(val) {
  const n = Number(val)
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
}

/** 将点数转为可读的字数标签，如 2000 → 「2 千字」 */
export function formatRewardChars(points) {
  const chars = toPoints(points)
  if (chars <= 0) {
    return '0 字'
  }
  if (chars >= 10000) {
    const wan = chars / 10000
    const text = wan % 1 === 0 ? String(wan) : wan.toFixed(1).replace(/\.0$/, '')
    return `${text} 万字`
  }
  if (chars >= 1000) {
    const k = chars / 1000
    const text = k % 1 === 0 ? String(k) : k.toFixed(1).replace(/\.0$/, '')
    return `${text} 千字`
  }
  return `${chars.toLocaleString()} 字`
}

/** 注册礼：场景化说明，让用户感知「能做什么」 */
export function describeNewMemberReward(points) {
  const chars = toPoints(points)
  const charLabel = formatRewardChars(points)
  let usageHint = '登录即到账，可直接试用降重、降 AIGC'
  if (chars >= 2000) {
    usageHint = '够改 2 篇摘要，或完整体验 1-2 段核心章节'
  } else if (chars >= 1000) {
    usageHint = '够处理 1 段千字级内容，零充值先跑通流程'
  } else if (chars > 0) {
    usageHint = '按实际字数扣减，先小范围试改看效果'
  }
  return {
    charLabel,
    usageHint,
    pointsLabel: `${chars.toLocaleString()} 点数`,
    actionLabel: chars > 0 ? `领 ${charLabel} 体验额度` : '微信登录体验'
  }
}

/** 邀请奖励：场景化说明 */
export function describeInviterReward(points) {
  const chars = toPoints(points)
  const charLabel = formatRewardChars(points)
  let usageHint = '好友通过您的邀请码注册，奖励发放给您'
  if (chars >= 1000) {
    usageHint = `每邀 1 人再得 ${charLabel}，够再改 1 段核心内容`
  } else if (chars > 0) {
    usageHint = `每邀 1 人再得 ${charLabel}，多邀多得`
  }
  return {
    charLabel,
    usageHint,
    pointsLabel: `${chars.toLocaleString()} 点数`
  }
}

/** 邀请页长文案 */
export function buildInvitePromoSentence(newMemberReward, inviterReward) {
  const register = describeNewMemberReward(newMemberReward)
  const invite = describeInviterReward(inviterReward)
  return `新用户微信注册即送 ${register.charLabel} 免费改写额度（${register.pointsLabel}，1 点 = 1 字）；成功邀请 1 位好友，您再得 ${invite.charLabel}（被邀请好友不再额外叠加邀请奖励）。`
}
